var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"mb-2 font-weight-bold"},[_vm._v("Image")]),_c('media-block',{attrs:{"title":"Image","type":"image"},model:{value:(_vm.fullPageImage.media),callback:function ($$v) {_vm.$set(_vm.fullPageImage, "media", $$v)},expression:"fullPageImage.media"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }